import React from "react";

export function ContainedBadge({ children, tone = "amber" }: { children: React.ReactNode; tone?: "amber" | "neutral" }) {
  const colours = tone === "amber" ? "bg-amber-400/20 text-amber-300" : "bg-muted text-muted-foreground";
  return <span className={`inline-flex max-w-full shrink-0 items-center rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${colours}`}>{children}</span>;
}
